// general component to display a message consistently across cards
import React from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { ThemedIcon, ThemedSpan } from "../../../components/utilities";

export const BaseWidgetMessages = {
    NoResult: "No results available",
    Error: "There was an error loading the data"
}

export type WidgetMessageProps = {
    icon?: IconProp
    message: string
};

const WidgetMessage = ({ icon = ['fas', 'exclamation-circle'], message }: Readonly<WidgetMessageProps>) => (
    <div className="col-12">
        <ThemedIcon variant="warning" className="me-2" icon={icon} size="lg" />
        <ThemedSpan variant="primary">{message}</ThemedSpan>
    </div>
);

export default WidgetMessage;